import React, { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../services/api';

export default function QuickTaskModal({ onClose, onSave, currentUser, selectedLocation }) {
  const [formData, setFormData] = useState({
    tytul: '',
    opis: '',
    kiedy: 'dzis'
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.tytul.trim()) return;

    setSaving(true);
    try {
      const today = new Date();
      let targetDate;
      if (formData.kiedy === 'jutro') {
        targetDate = new Date(today);
        targetDate.setDate(targetDate.getDate() + 1);
      } else {
        targetDate = today;
      }
      const termin = targetDate.toISOString().split('T')[0];

      const taskData = {
        tytul: formData.tytul,
        opis: formData.opis,
        kategoria: formData.kiedy,
        termin_wykonania: termin,
        priorytet: 'normalny',
        status: 'nowe',
        location_id: selectedLocation || '',
        utworzyl: currentUser?.login || 'system'
      };

      const response = await api.post('/tasks', taskData);

      const data = response.data;
      if (data.success) {
        onSave();
      } else {
        toast.error('Błąd zapisu: ' + (data.error || 'Nieznany błąd'));
      }
    } catch (error) {
      console.error('Error saving quick task:', error);
      toast.error('Błąd zapisu: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '1rem'
    }}>
      <div style={{
        background: "var(--card-bg)",
        borderRadius: '10px',
        width: '400px',
        maxWidth: '95vw',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
      }}>
        {/* Header */}
        <div style={{
          padding: '1rem 1.25rem',
          border: '1px solid var(--orange)',
          color: 'var(--orange)',
          borderRadius: '10px 10px 0 0',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem'
        }}>
          <div style={{
            width: '2.5rem',
            height: '2.5rem',
            background: 'transparent',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.25rem'
          }}>
            {'⚡'}
          </div>
          <div style={{ flex: 1 }}>
            <h5 style={{ margin: 0, fontWeight: 700, fontSize: '16px' }}>
              Szybkie zadanie
            </h5>
            <p style={{ margin: 0, fontSize: '11px', opacity: 0.8 }}>
              Dodaj zadanie w kilka sekund
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              fontSize: '1.25rem',
              color: 'var(--text-secondary)',
              padding: '0.5rem',
              lineHeight: 1
            }}
          >
            {'✕'}
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: '1.25rem' }}>
          {/* Title */}
          <div style={{ marginBottom: '1rem' }}>
            <label style={{
              display: 'block',
              fontSize: '12px',
              fontWeight: 600,
              color: 'var(--text-secondary)',
              marginBottom: '6px'
            }}>
              Co trzeba zrobić? *
            </label>
            <input
              type="text"
              value={formData.tytul}
              onChange={(e) => setFormData({ ...formData, tytul: e.target.value })}
              style={{
                width: '100%',
                padding: '12px 14px',
                border: '2px solid var(--border)',
                borderRadius: '8px',
                fontSize: '14px',
                boxSizing: 'border-box',
                transition: 'border-color 0.2s'
              }}
              placeholder="Nazwa zadania..."
              autoFocus
            />
          </div>

          {/* Description */}
          <div style={{ marginBottom: '1rem' }}>
            <label style={{
              display: 'block',
              fontSize: '12px',
              fontWeight: 600,
              color: 'var(--text-secondary)',
              marginBottom: '6px'
            }}>
              Opis (opcjonalnie)
            </label>
            <textarea
              value={formData.opis}
              onChange={(e) => setFormData({ ...formData, opis: e.target.value })}
              style={{
                width: '100%',
                padding: '12px 14px',
                border: '2px solid var(--border)',
                borderRadius: '8px',
                fontSize: '14px',
                minHeight: '70px',
                resize: 'vertical',
                boxSizing: 'border-box'
              }}
              placeholder="Dodatkowe szczegóły..."
            />
          </div>

          {/* When: Today / Tomorrow */}
          <div style={{ marginBottom: '1.25rem' }}>
            <label style={{
              display: 'block',
              fontSize: '12px',
              fontWeight: 600,
              color: 'var(--text-secondary)',
              marginBottom: '8px'
            }}>
              Kiedy?
            </label>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                type="button"
                onClick={() => setFormData({ ...formData, kiedy: 'dzis' })}
                style={{
                  flex: 1,
                  padding: '14px 20px',
                  border: formData.kiedy === 'dzis' ? '2px solid var(--danger)' : '2px solid var(--border)',
                  borderRadius: '10px',
                  background: formData.kiedy === 'dzis' ? 'var(--danger-light)' : 'var(--card-bg)' ,
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                <span style={{ fontSize: '24px' }}>{'📅'}</span>
                <span style={{
                  fontWeight: 600,
                  fontSize: '14px',
                  color: formData.kiedy === 'dzis' ? 'var(--danger)' : 'var(--text-secondary)'
                }}>
                  DZIŚ
                </span>
                <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                  {new Date().toLocaleDateString('pl-PL', { weekday: 'short', day: 'numeric', month: 'short' })}
                </span>
              </button>

              <button
                type="button"
                onClick={() => setFormData({ ...formData, kiedy: 'jutro' })}
                style={{
                  flex: 1,
                  padding: '14px 20px',
                  border: formData.kiedy === 'jutro' ? '2px solid var(--orange)' : '2px solid var(--border)',
                  borderRadius: '10px',
                  background: formData.kiedy === 'jutro' ? 'var(--warning-light)' : 'var(--card-bg)' ,
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                <span style={{ fontSize: '24px' }}>{'📆'}</span>
                <span style={{
                  fontWeight: 600,
                  fontSize: '14px',
                  color: formData.kiedy === 'jutro' ? 'var(--orange)' : 'var(--text-secondary)'
                }}>
                  JUTRO
                </span>
                <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                  {(() => {
                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    return tomorrow.toLocaleDateString('pl-PL', { weekday: 'short', day: 'numeric', month: 'short' });
                  })()}
                </span>
              </button>
            </div>
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                flex: 1,
                padding: '6px 12px',
                border: '1px solid var(--text-muted)', color: 'var(--text-muted)',
                fontWeight: 500,
                fontSize: '12px'
              }}
            >
              Anuluj
            </button>
            <button
              type="submit"
              disabled={saving || !formData.tytul.trim()}
              style={{
                flex: 2,
                padding: '6px 12px',
                border: '1px solid var(--orange)',
                color: 'var(--orange)',
                fontWeight: 700,
                fontSize: '12px',
                opacity: (saving || !formData.tytul.trim()) ? 0.6 : 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              {saving ? '⏳ Zapisuję...' : '⚡ Dodaj zadanie'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
